import React from 'react';
import cx from 'classnames';

import { FieldRenderProps } from '../types';

/**
 * Text Field Area component. It follows the props from react-final-form
 */
interface IInputTextArea extends FieldRenderProps<HTMLElement> {
  /** Passed down classname. */
  className?: string;
  /** Optional id indicator */
  id?: string;
  /** If background has a solid color */
  isReverse?: boolean;
  /** Is small */
  isSmall?: boolean;
  /** Optional title */
  title?: string;
  /** Ability to control resize */
  resize?: 'none' | 'vertical' | 'unset';
}

export const InputTextArea: React.FC<IInputTextArea> = ({
  className,
  id,
  input: { name, onBlur, onChange, onFocus, value },
  isSmall = false,
  isReverse = false,
  meta: { active },
  title,
  resize,
}) => {
  const combinedContainerClass = cx({
    'panda-input-container': true,
    [className || '']: !!className,
  });
  const combinedInputClass = cx({
    'panda-input-text-area': true,
    'panda-input--small': isSmall,
    'panda-input--large': !isSmall,
    'panda-typography--P2': isSmall,
    'panda-typography--P1': !isSmall,
    'panda-input-text--focused': !!active,
  });
  const combinedLabelClass =
    !!title &&
    cx({
      'panda-input-title--large': !isSmall,
      'panda-input-title--small': isSmall,
      'panda-input-title--white': isReverse,
    });

  return (
    <div className={combinedContainerClass}>
      {!!title && <label className={combinedLabelClass || ''}>{title}</label>}
      <textarea
        className={combinedInputClass}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
        style={{ resize: resize || 'none', backgroundColor: 'white' }}
      />
    </div>
  );
};
